import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { brand } = Dictionary

const brandService = {
  brandList: async (paramsObj: {}) => {
    return axios.get(BASE_URL + brand?.BrandList(), { params: paramsObj })
  },

  AddBrand: async (payload: {}) => {
    return axios.post(BASE_URL + brand.AddBrand(), payload)
  },
  editBrandDiscount:async (payload:{},id:string)=>{
    return axios.put(BASE_URL + brand.editBrandDiscount(id),payload)
  },
  deleteBrand: async (id: string) => {
    return axios.delete(BASE_URL + brand.deleteBrand(id))
  },

  UnRecognizedBrandSearch: async (payload: {}) => {
    return axios.post(BASE_URL + brand.brandSearch(), payload)
  },

  // change online and offline status
  onlineStatus: async (id:string) => {
    return axios.patch(BASE_URL + brand?.onlineStatus(id),)
  },

  
}
export default brandService
